import { Box, Dialog, DialogTitle, DialogContent, Button } from "@mui/material";
import { useState } from "react";
import { MEMBERSHIP_OPTIONS, MembershipOption } from "../signup/types";
import { MembershipOptionCard } from "../signup/components/MembershipOptionCard";

interface MembershipSelectionModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (membership: MembershipOption) => void;
}

export default function MembershipSelectionModal({
  open,
  onClose,
  onSelect,
}: MembershipSelectionModalProps) {
  const [selectedPlan, setSelectedPlan] = useState<number | null>(null);

  const handleSelect = () => {
    if (selectedPlan === null) return;
    onSelect(MEMBERSHIP_OPTIONS[selectedPlan]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Select Membership Plan</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            padding: "20px 0",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              maxWidth: "500px",
            }}
          >
            {MEMBERSHIP_OPTIONS.map((option, idx) => (
              <MembershipOptionCard
                key={option.name}
                option={option}
                isSelected={selectedPlan === idx}
                onClick={() => setSelectedPlan(idx)}
              />
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              marginTop: "16px",
            }}
          >
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSelect}
              disabled={selectedPlan === null}
            >
              Select Plan
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
